export const ETimePeriod = {
  SevenDays: "7d",
  FourteenDays: "14d",
  ThirtyDays: "30d",
  SixtyDays: "60d",
  NinetyDays: "90d",
  Custom: "custom",
} as const;

export type TTimePeriod = (typeof ETimePeriod)[keyof typeof ETimePeriod];

export const daysMap: Record<"7d" | "14d" | "30d" | "60d" | "90d", number> = {
  [ETimePeriod.SevenDays]: 7,
  [ETimePeriod.FourteenDays]: 14,
  [ETimePeriod.ThirtyDays]: 30,
  [ETimePeriod.SixtyDays]: 60,
  [ETimePeriod.NinetyDays]: 90,
};
